<template>
  <div>
    <OnexAlert :type="Notifications[getMessageType]" icon>
      {{ getInfoMessageTwo }}
    </OnexAlert>
    <div class="mt-4 pb-4" :class="$vuetify.display.xs ? 'pl-8' : 'px-8'">
      <v-row wrap class="mb-4 pb-4 mt-4">
        <v-col cols="12">
          <v-row wrap>
            <v-col>
              <h4>{{ $t('L_choose_how_often_you_would_like_to_pay_your_bill') }}</h4>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" md="4">
              <!-- Monthly Bank Draft Cards -->
              <SelectionBox
                :card-disabled="currentBankDraftMonthly"
                :is-selected="selectedType === '1bd'"
                :card-title="$t('L_every_month_by_automatic_bank_withdrawal')"
                :card-title-sub="$t('L_every_month')"
                :card-amount="getMonthlyAmount"
                :show-footer-note="false"
                @selected="selectedType = '1bd'"
              />
              <div
                class="billingLink mb-4"
                @click="showDirectBillCards"
                v-if="!isDirectBillCardsDisplayed"
              >
                {{ $t('L_view_other_billing_options') }}
              </div>
            </v-col>
            <v-col cols="12" v-if="isDirectBillCardsDisplayed">
              <v-row wrap>
                <v-col cols="12" sm="6" md="4" v-if="currentDirectBillMonthly">
                  <!-- Monthly Direct Bill Cards -->
                  <SelectionBox
                    :card-disabled="currentDirectBillMonthly"
                    :is-selected="selectedType === '1db'"
                    :card-title="$t('L_monthly_direct_bill')"
                    :card-title-sub="$t('L_every_month')"
                    :card-amount="getMonthlyAmount"
                    :show-footer-note="false"
                    @selected="selectedType = '1db'"
                  />
                </v-col>
                <!-- Quarterly Direct Bill Cards -->
                <v-col cols="12" sm="6" md="4">
                  <SelectionBox
                    :card-disabled="currentDirectBillQuarterly"
                    :is-selected="selectedType === '3db'"
                    :card-title="$t('L_every_three_months')"
                    :card-title-sub="$t('L_every_three_months_sub')"
                    :card-amount="getQuarterlyDirectBillAmount"
                    :show-footer-note="false"
                    @selected="selectedType = '3db'"
                  />
                </v-col>
                <!-- Semi Annual Direct Bill Cards -->
                <v-col cols="12" sm="6" md="4">
                  <SelectionBox
                    :card-disabled="currentDirectBillSemiAnnual"
                    :is-selected="selectedType === '6db'"
                    :card-title="$t('L_every_six_months')"
                    :card-title-sub="$t('L_every_six_months_sub')"
                    :card-amount="getSemiAnnualDirectBillAmount"
                    :show-footer-note="false"
                    @selected="selectedType = '6db'"
                  />
                </v-col>
                <!-- Annual Direct Bill Cards -->
                <v-col cols="12" sm="6" md="4">
                  <SelectionBox
                    :card-disabled="currentDirectBillAnnual"
                    :is-selected="selectedType === '12db'"
                    :card-title="$t('L_once_a_year')"
                    :card-title-sub="$t('L_once_a_year_sub')"
                    :card-amount="getAnnualDirectBillAmount"
                    :show-footer-note="false"
                    @selected="selectedType = '12db'"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-end mb-4">
        <v-col cols="12" sm="4" md="3" class="px-4">
          <OnexButton block variant="outlined" color="outlined" @click="cancelPayment">
            {{ $t('L_cancel') }}
          </OnexButton>
        </v-col>
        <v-col cols="12" sm="4" md="3" class="px-4">
          <OnexButton block @click="goToNextStep" :disabled="selectedType === '-1'">
            {{ $t('L_continue') }}
          </OnexButton>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mapState, mapActions } from 'pinia';
import MessageDialog from '../../../../../components/MessageDialog.vue';
import SelectionBox from './component/selectionBox.vue';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { Notifications, OnexAlert, OnexButton } from '@primerica/onex-ui-lib';
import { mdiAlert, mdiInformationOutline } from '@mdi/js';

const componentOptions: ComponentOptions = {
  name: 'BankAccountTypeChangeStepOne',
  components: {
    MessageDialog,
    SelectionBox,
    OnexAlert,
    OnexButton,
  },
  data: () => ({
    isDirectBillCardsDisplayed: false,
    selectedType: '-1',
    processCompleted: false,
    Notifications,
  }),
  props: {
    selectedOption: {
      type: String,
      required: false,
      default: '-1',
    },
    // existingBankInfo: {
    //   type: Object,
    //   required: true,
    // },
  },
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
      dateFormat: 'getDateFormat',
    }),
    ...mapState(usePolicyStore, {
      paymentData: 'paymentData',
      policyData: 'currentPolicy',
      showPayNowButton: 'showPayNow',
      preLoadBank: 'preLoadBank',
    }),
    icon() {
      if (this.type === 'warning') {
        return mdiAlert;
      } else if (this.type === 'info') {
        return mdiInformationOutline;
      }
    },
    showMessage() {
      // Only show the message if the user selects Bank Draft
      return this.selectedType === '1bd' && (this.policyData?.paynowInfo?.isPastDue || false);
    },
    getMessageType() {
      // const paidToDate = this.policyData?.paymentInfo?.paidToDate;
      // const isPaidToDateBeforeToday = moment(paidToDate).isBefore(moment(), 'day');
      const isPaidToDateBeforeToday = this.policyData?.paynowInfo?.isPastDue;
      const billForm = this.policyData?.billingForm;
      const DIRECT_BILL = billForm?.toLowerCase() === 'A1'.toLowerCase();
      let noOptionSelected = false;
      if (this.selectedType === '-1' || this.selectedType === '') {
        noOptionSelected = true;
      }

      if (noOptionSelected) {
        return 'info';
      } else if (DIRECT_BILL) {
        // Currently on direct bill
        if (this.selectedType === '1bd') {
          // Selected Bank Draft
          if (isPaidToDateBeforeToday) {
            // that has a past due amount
            return 'warning';
          } else {
            // no past due amount
            return 'info';
          }
        } else {
          // Selecting other direct bill
          return 'info';
        }
      } else if (this.currentBankDraftMonthly) {
        return 'info';
      } else {
        return 'info';
      }
    },
    getInfoMessageTwo() {
      // DB to BD.  Flag is true show the message that is not w PACPremium
      // this.policyData?.paynowInfo?.pastDueAmount
      // let payNowLinkDesc = this.policyData?.payNowLinkDesc || '';
      // const paidToDate = this.policyData?.paymentInfo?.paidToDate;
      const isPaidToDateBeforeToday = this.policyData?.paynowInfo?.isPastDue;
      const billForm = this.policyData?.billingForm;
      const DIRECT_BILL = billForm?.toLowerCase() === 'A1'.toLowerCase();
      let payNowLinkDesc;
      let noOptionSelected = false;
      if (this.selectedType === '-1' || this.selectedType === '') {
        noOptionSelected = true;
      }
      // const BANK_DRAFT = this.policyData?.paymentInfo?.billForm.toLowerCase() === 'b2';
      // const isPaidToDateBeforeToday = moment(paidToDate).isBefore(moment(), 'day');
      if (noOptionSelected) {
        if (DIRECT_BILL) {
          payNowLinkDesc = this.$t('L_want_an_easier_way_to_pay');
        } else {
          payNowLinkDesc = this.$t('L_are_you_sure_you_want');
        }
      } else if (DIRECT_BILL) {
        // Currently on direct bill
        if (this.selectedType === '1bd') {
          // Selected Bank Draft
          if (isPaidToDateBeforeToday) {
            // that has a past due amount
            payNowLinkDesc = this.$t('L_please_note_that_because_you_have_a_past_due', {
              amount: this.policyData?.paynowInfo?.pastDueAmount,
            });
          } else {
            // no past due amount
            payNowLinkDesc = this.$t('L_want_a_more_convenient');
          }
        } else {
          // Selecting other direct bill
          payNowLinkDesc = this.$t('L_want_a_more_convenient');
        }
      } else if (this.currentBankDraftMonthly) {
        if (
          this.selectedType === '3db' ||
          this.selectedType === '6db' ||
          this.selectedType === '12db'
        ) {
          payNowLinkDesc = this.$t('L_are_you_sure_you_want');
        } else {
          payNowLinkDesc = '';
        }
      } else {
        payNowLinkDesc = '';
      }
      return payNowLinkDesc;
    },
    currentDirectBillMonthly() {
      if (
        this.policyData?.paymentInfo?.billMode === '01' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentDirectBillQuarterly() {
      if (
        this.policyData?.paymentInfo?.billMode === '03' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentDirectBillSemiAnnual() {
      if (
        this.policyData?.paymentInfo?.billMode === '06' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentDirectBillAnnual() {
      if (
        this.policyData?.paymentInfo?.billMode === '12' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentBankDraftMonthly() {
      if (this.policyData?.paymentInfo?.billForm.toLowerCase() === 'b2') {
        return true;
      }
      return false;
    },
    getMonthlyAmount() {
      return this.policyData?.paymentInfo?.PACPremium + '' || '';
    },
    getQuarterlyDirectBillAmount() {
      return this.policyData?.paymentInfo?.quarterlyPremium + '' || '';
    },
    getSemiAnnualDirectBillAmount() {
      return this.policyData?.paymentInfo?.semiAnnualPremium + '' || '';
    },
    getAnnualDirectBillAmount() {
      return this.policyData?.paymentInfo?.annualPremium + '' || '';
    },
  },
  methods: {
    ...mapActions(useGlobalStore, {
      removeAlerts: 'removeAlerts',
    }),
    cancelPayment() {
      this.$emit('cancel');
    },
    goToNextStep() {
      let amount = '';
      if (this.selectedType === '1bd') {
        amount = this.getMonthlyAmount + '';
      } else if (this.selectedType === '1db') {
        amount = this.getMonthlyAmount + '';
      } else if (this.selectedType === '3db') {
        amount = this.getQuarterlyDirectBillAmount + '';
      } else if (this.selectedType === '6db') {
        amount = this.getSemiAnnualDirectBillAmount + '';
      } else if (this.selectedType === '12db') {
        amount = this.getAnnualDirectBillAmount + '';
      }
      this.$emit('paymentAmount', amount);
      this.$emit('goToStepTwo', this.selectedType);
    },
    showDirectBillCards() {
      this.isDirectBillCardsDisplayed = true;
    },
  },
  mounted() {
    this.processCompleted = false;
    this.selectedType = this.selectedOption;
    this.removeAlerts('payment');
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.billingLink {
  color: #02579e;
  font-size: 14px;
  font-weight: 600;
}
</style>
